{
  "titles": {
    "menu": "Spaarders",
    "table": "Spaarders",
    "create": "Spaarder aanmaken",
    "update": "Spaarder wijzigen",
    "contracts": "Contracten",
    "accounts": "Accounts",
    "details": "Algemeen",
    "funderInformation": "Informatie spaarder",
    "files": "Documenten",
    "archivedFiles": "Gearchiveerd"
  },
  "fields": {
    "labels": {
      "businessName": "Bedrijfsnaam",
      "legalStructure": "Rechtsvorm",
      "registrationNumber": "KvK-nummer",
      "registeredOffice": "Statutaire zetel",
      "officeAddress": "Adres",
      "representativeName": "Vertegenwoordiger",
      "advisorId": "Adviseur",
      "type": "Soort spaarder",
      "name": "Spaarder naam",
      "isBusinessInformationValidated": "KvK uittreksel & statuten controle",
      "isIdentityValidated": "Identiteit spaarder controle",
      "false-isIdentityValidated": "Identiteit spaarder is niet gecontroleerd",
      "false-isBusinessInformationValidated": "KvK uittreksel & statuten zijn niet gecontroleerd",
      "representativeId": "Vertegenwoordiger",
      "representativeEmail": "E-mailadres",
      "representativePhone": "Telefoonnummer",
      "email": "E-mailadres",
      "phone": "Telefoonnummer",
      "signingAuthorities": "Tekenbevoegden",
      "isAllowedToManageContracts": "Mag eigen contracten beheren",
      "hasAccesToFunderPortal": "Toegang tot het spaarders portaal"
    },
    "hints": {
    }
  },
  "headers": {
    "labels": {
      "advisorName": "Adviseur",
      "numberOfActiveContracts": "Actieve contracten",
      "totalActiveContractAmount": "Actieve inleg",
      "name": "Naam"
    }
  },
  "messages": {
    "createSuccess": "Spaarder aangemaakt",
    "updateSuccess": "Spaarder is opgeslagen",
    "noAdvisorId": "Eigen netwerk",
    "isRepresentative": "vertegenwoordiger",
    "checkedAtBy": "Gecontroleerd op {date} door {name}",
    "noFiles": "Geen documenten beschikbaar"
  },
  "actions": {
    "create": "Spaarder aanmaken",
    "update": "Spaarder aanpassen",
    "search": "Zoek een spaarder"
  },
  "declarationOfSourceOfFunds": {
    "titles": {
      "newAdditionalDocument": "Nieuw aanvullend document"
    },
    "fields": {
      "labels": {
        "fundingContractReferenceNumber": "Gekoppeld aan",
        "archivedFundingContractReferenceNumbers": "Gekoppeld aan {count} contracten",
        "additionalDocumentType": "Soort document",
        "description": "Beschrijving",
        "file": "Document"
      }
    },
    "actions": {
      "toggleAdditionalDocuments": "Aanvullende documenten",
      "openNewAdditionalDocumentForm": "Aanvullend document toevoegen",
      "addAdditionalDocument": "Toevoegen"
    }
  }
}
